export enum NoticeType {
  Contract = "CONTRACT",
  ContractAward = "CONTRACT_AWARD",
  PriorInformation = "PRIOR_INFORMATION",
  PriorInformationShortenTimeLimits = "PRIOR_INFORMATION_SHORTEN_TIME_LIMITS",
}
